<template>
<el-container>
    <el-header class="header">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }" style="font-size: 16px;">Home</el-breadcrumb-item>
        <el-breadcrumb-item style="font-size: 16px;">TFs-Enhancer</el-breadcrumb-item>
    </el-breadcrumb>
    </el-header>
    <el-aside width="3px"></el-aside>
    <el-main>
    <el-container>
        <el-aside class="aside">
        <div>
            <Tfselect @search="handleSearch" />
        </div>
        </el-aside>
        <el-main>
        <div v-if="selectedSpecies !== '' && selectedTissue !== '' && selectedTf !== ''">
                <!-- 在选择了物种和组织类型后显示 Shippanel 组件 -->
            <Tfpanel :species="selectedSpecies" :tissue="selectedTissue" :tf="selectedTf" :key="selectedSpecies + selectedTissue + selectedTf" />
        </div>
        </el-main>
    </el-container>
    </el-main>
    <el-aside width="3px"></el-aside>
</el-container>
</template>

<script>
import Tfselect from './Tfselect.vue';
import Tfpanel from './Tfpanel.vue';

export default {
    components: {
        Tfselect,Tfpanel
    },
    data() {
        return {
            selectedSpecies: '',
            selectedTissue: [],
            selectedTf: '',
        };
    },
    created() {
        // 在组件创建时，设置默认参数值
        this.selectedSpecies = 'mouse';
        this.selectedTissue = ['heart embryo (11.5 days)','heart embryo (12.5 days)','heart embryo (14.5 days)','heart embryo (15.5 days)',
                    'heart embryo (16.5 days)','heart postnatal (0 days)'];
        this.selectedTf = 'SOX17';
    },
    methods: {
        handleSearch(params) {
            this.selectedSpecies = params.Species;
            this.selectedTissue = params.Tissue;
            this.selectedTf = params.Tfbs;
        }
    }
};
</script>

<style scoped>
.header {
    padding: 0px;
    border-bottom: 1px solid #ccc;
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    margin-top: 60px;
}
.aside {
    width: 240px;
    border-right: 1px dashed #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Tf.vue